// import {
//   SalesAppointmentsCreatePage,
//   SalesAppointmentsDetailPage,
//   SalesAppointmentsListPage
// } from 'domains/sales/appointments'
import { SalesDealsCreatePage } from 'domains/sales/deals'
import { SalesDealsListPage } from 'domains/sales/deals/pages'
import { SalesDealsDetailPage } from 'domains/sales/deals/pages'
import { SalesShipmentListPage } from 'domains/sales/deals/pages'

const sales_team_routes = {
  collapse  : true,
  path      : '/sales',
  name      : 'Sales Team',
  icon      : 'fas fa-cart-arrow-down text-blue',
  state_key : 'sales_team_collapse',
  views     : [
    {
      path      : '/sales/deals/create',
      name      : 'Create Deal',
      miniName  : 'D',
      component : SalesDealsCreatePage,
      layout    : '/app'
    },
    {
      path      : '/sales/deals/',
      name      : 'Deal List',
      miniName  : 'D',
      component : SalesDealsListPage,
      layout    : '/app',
    },
    {
      path      : '/sales/deals?scope=ready_to_ship',
      name      : 'Shipment List',
      miniName  : 'L',
      component : SalesShipmentListPage,
      layout    : '/app'
    },
    {
      path      : '/sales/deals/:id',
      name      : 'Deal Detail',
      miniName  : 'D',
      component : SalesDealsDetailPage,
      layout    : '/app',
      invisible : true
    },
    // {
    //   path      : '/sales/appointment/create',
    //   name      : 'Create Appointment',
    //   miniName  : 'C',
    //   component : SalesAppointmentsCreatePage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/sales/appointment/list',
    //   name      : 'Appointments List',
    //   miniName  : 'L',
    //   component : SalesAppointmentsListPage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/sales/appointments/:id',
    //   name      : 'Sales Appointment Detail',
    //   miniName  : 'SlsApp',
    //   component : SalesAppointmentsDetailPage,
    //   layout    : '/app',
    //   invisible : true
    // }
  ]
}

export default sales_team_routes
